import React from 'react';
import { DisabledTag } from '@nile/components';
import { FormattedMessage, injectIntl } from 'react-intl';

function CustomFieldCell(props) {
  const { cell } = props;
  const rowValue = cell?.row?.original;

  const columnAccessorKey = cell?.column?.accessor;

  let customFieldKey = columnAccessorKey;

  let displayValue = '';

  if (
    columnAccessorKey?.split('.')?.length > 1 &&
    columnAccessorKey?.split('.')?.[0] === 'client'
  ) {
    customFieldKey = columnAccessorKey?.split('.')[
      columnAccessorKey?.split('.')?.length - 1
    ];

    displayValue =
      typeof rowValue?.client?.customFields?.[customFieldKey] === 'object' &&
      rowValue?.client?.customFields?.[customFieldKey]?.length > 0
        ? rowValue?.client?.customFields?.[customFieldKey]?.join(', ')
        : rowValue?.client?.customFields?.[customFieldKey];
  } else {
    displayValue =
      typeof rowValue?.customFields?.[customFieldKey] === 'object' &&
      rowValue?.customFields?.[customFieldKey]?.length > 0
        ? rowValue?.customFields?.[customFieldKey]?.join(', ')
        : rowValue?.customFields?.[customFieldKey];
  }

  return displayValue ? (
    <div className="flex center ellipsis" title={displayValue}>
      {displayValue}
    </div>
  ) : (
    <DisabledTag>
      <FormattedMessage id="app.noData.message" />
    </DisabledTag>
  );
}

export default injectIntl(CustomFieldCell);
